<template>
  <div class="app-container" style="padding: 0;">
    <div class="wt-form-inputs-container">
      <div class="dashboard-container">
        <div class="bottom-info-row">
          <div class="info-item">
            <span class="info-label">投递次数:</span>
            <span class="info-value">{{ this.dateil.two }} 次</span>
          </div>
          <div class="info-item">
            <span class="info-label">投递人数:</span>
            <span class="info-value">{{ this.dateil.three }} 人</span>
          </div>
          <div class="info-item">
            <span class="info-label">投递金额:</span>
            <span class="info-value">{{ this.dateil.four }} 元</span>
          </div>
          <div class="info-item">
            <span class="info-label">投递重量:</span>
            <span class="info-value">{{ this.dateil.one }} kg</span>
          </div>
        </div>
        <div class="bottom-info-row">
          <div class="info-item">
            <span class="info-label">违投次数:</span>
            <span class="info-value">{{ this.dateil.five }} 次</span>
          </div>
          <div class="info-item">
            <span class="info-label">新增用户数量:</span>
            <span class="info-value">{{ this.dateil.six }} 人</span>
          </div>
          <div class="info-item">
            <span class="info-label">用户总量:</span>
            <span class="info-value">{{ this.dateil.seven }} 人</span>
          </div>
          <div class="info-item"></div>
        </div>
      </div>
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="统计时间：">
            <el-select v-model="form.type" filterable placeholder="请选择">
              <el-option
                v-for="item in dateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small" @click="toClickAction('reset')">重置</el-button>
        </el-form>
      </div>
      <el-card class="chart-card">
        <div class="card-header">
          <span style="font-weight: bold;font-size: 14px;">图表类型:</span>
          <el-select v-model="type" filterable placeholder="请选择" @change="change" style="width: 200px;">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <h2>{{ this.title }}</h2>
        </div>
        <LineChart :chartData="tdList" height="calc(52vh)"></LineChart>
      </el-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TwoDetail',
  isAutoComponent: true,
  data() {
    return {
      form: {
        type: 'day'
      },
      dateil: {},
      type: '1',
      title: '投递重量统计',
      dateList: [
        { label: '天', value: 'day' },
        { label: '周', value: 'week' },
        { label: '月', value: 'month' },
        { label: '年', value: 'year' }
      ],
      typeList: [
        { label: '投递重量', value: '1' },
        { label: '投递次数', value: '2' },
        { label: '投递人数', value: '3' },
        { label: '投递金额', value: '4' },
        { label: '违规次数', value: '5' },
        { label: '新增用户', value: '6' },
        { label: '累计用户', value: '7' }
      ],
      tdList: {}
    }
  },
  created() {
    this.initPage()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.$api.statistical.workbenchIndex.index(this.form).then(res => {
        const date = res.data.fullComprehensive.map(item => item.statsDate)
        const one = res.data.fullComprehensive.map(item => item.deliveryWeight)
        const two = res.data.fullComprehensive.map(item => item.deliveryCount)
        const three = res.data.fullComprehensive.map(item => item.deliveryUsers)
        const four = res.data.fullComprehensive.map(item => item.userReceivedAmount)
        const five = res.data.fullComprehensive.map(item => item.unlawfulDeliveryCount)
        const six = res.data.fullComprehensive.map(item => item.newUsers)
        const seven = res.data.fullComprehensive.map(item => item.cumulativeUsers)
        this.dateil = {
          one: one.reduce((sum, num) => sum + Number(num || 0), 0),
          two: two.reduce((sum, num) => sum + Number(num || 0), 0),
          three: three.reduce((sum, num) => sum + Number(num || 0), 0),
          four: four.reduce((sum, num) => sum + Number(num || 0), 0).toFixed(2),
          five: five.reduce((sum, num) => sum + Number(num || 0), 0).toFixed(2),
          six: six.reduce((sum, num) => sum + Number(num || 0), 0),
          seven: seven.reduce((sum, num) => sum + Number(num || 0), 0)
        }
        let list = []
        if (this.type === '1') {
          list = one
        } else if (this.type === '2') {
          list = two
        } else if (this.type === '3') {
          list = three
        } else if (this.type === '4') {
          list = four
        } else if (this.type === '5') {
          list = five
        } else if (this.type === '6') {
          list = six
        } else if (this.type === '7') {
          list = seven
        }
        this.tdList = {
          xAxisData: date,
          line: [
            { name: '',
              data: list,
              label: true,
              color: '#E6A23C',
              areaColor: '#FDF6EC' }
          ]
        }
      })
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          type: 'day'
        }
      }
      this.initPage()
    },
    change() {
      this.title = this.typeList.filter((row) => row.value === this.type).map((data) => data.label) + '统计'
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

/* 每一行容器 */
.bottom-info-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 160px;
}

.info-label {
  flex: 0 0 110px;
  white-space: nowrap;
}

.info-value {
  flex: 1;
  white-space: nowrap;
  text-align: left;
}

</style>
